/** Corrige rombos/tildes/Ñ en Oficina. */

const CITY_FFFD_FIXES = [
  [/ALCAL\uFFFD/gi, 'ALCALÁ'],
  [/ACAC\uFFFD\s*AS/gi, 'ACACÍAS'],
  [/ACAC\uFFFDAS/gi, 'ACACÍAS'],
  [/ITAG\uFFFD\uFFFD?/gi, 'ITAGÜÍ'],
  [/ITAG\uFFFD/gi, 'ITAGÜÍ'],
  [/ITAGI\uFFFD/gi, 'ITAGÜÍ'],
  [/MEDELL\uFFFDN/gi, 'MEDELLÍN'],
  [/BOGOT\uFFFD/gi, 'BOGOTÁ'],
];

function fixNameFffd(s) {
  return String(s)
    .replace(/([A-ZÁÉÍÓÚÜ])\uFFFD([AEIOUÁÉÍÓÚÜ])/g, '$1Ñ$2')
    .replace(/([a-záéíóúü])\uFFFD([aeiouáéíóúü])/g, '$1ñ$2')
    .replace(/([A-ZÁÉÍÓÚÜ])\uFFFD([Nn])/g, '$1Ñ$2')
    .replace(/([a-záéíóúü])\uFFFD([Nn])/g, '$1ñ$2');
}

export function fixText(value) {
  if (value == null) return value;
  let s = String(value);
  if (!s) return s;
  if (/\uFFFD/.test(s)) {
    for (const [re, fixed] of CITY_FFFD_FIXES) s = s.replace(re, fixed);
    s = fixNameFffd(s);
    s = s.replace(/\uFFFD+/g, '').trim() || String(value).replace(/\uFFFD+/g, '');
  }
  if (!/Ã.|Â./i.test(s)) return s;
  try {
    const bytes = Uint8Array.from(s, (ch) => ch.charCodeAt(0) & 0xff);
    const fixed = new TextDecoder('utf-8').decode(bytes);
    if (fixed && !fixed.includes('\uFFFD') && fixed !== s) return fixed;
  } catch {
    /* ignore */
  }
  return s;
}

export function fixClienteRow(row) {
  if (!row || typeof row !== 'object') return row;
  return {
    ...row,
    nombre: fixText(row.nombre),
    display_nombre: fixText(row.display_nombre),
    etiqueta: fixText(row.etiqueta),
    sede_etiqueta: fixText(row.sede_etiqueta),
    ciudad: fixText(row.ciudad),
    zona: fixText(row.zona),
    direccion: fixText(row.direccion),
    vendedor_nombre: fixText(row.vendedor_nombre),
    padre_nombre: fixText(row.padre_nombre),
  };
}

/** Etiqueta de entrega a sede/sucursal bajo un cliente padre. */
export function pedidoClienteLabel(pedido) {
  if (!pedido) return '—';
  const nombre = fixText(pedido.cliente_nombre) || '—';
  if (pedido.es_sede || pedido.padre_codigo) {
    const padre = pedido.padre_codigo || '';
    const sede = fixText(pedido.sede_etiqueta) || 'Sede';
    return padre ? `${padre} · Sucursal: ${sede}` : `Sucursal: ${sede}`;
  }
  return nombre;
}
